<template>
	<div v-if="isBlockShown" class="col-12">
		<div class="panel_header">
			<div class="row align-items-end">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p>{{ block.subtitle }}</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="py-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<div v-else>
			<FormulateForm
				v-if="mounted && autocompleted"
				v-model="formValues"
				:schema="schema"
				class="row"
				@submit="submit"
				@setValidation="setValidation"
				@setDisabled="setDisabled"
				@validatePhone="validatePhone"
			>
				<div v-if="allProductsFromGroup" class="col-12 order-0">
					<div class="row">
						<div class="col-12 col-lg-6 mb-4">
							<products-component
								v-model="products"
								:block="block"
								@handlerChange="handlerChange"
							/>
						</div>
					</div>
				</div>

				<div v-if="isShowDonationBlock" class="col-12 order-0">
					<div class="row">
						<div class="col-12 col-lg-6 order-0 mb-4">
							<div class="mb-4">
								<!-- <button
									type="button"
									class="btn btn-outline-primary mr-2"
									@click="formValues.donation_amount = 200000"
								>
									200 000 ₽
								</button> -->

								<!-- <button
									type="button"
									class="btn btn-outline-primary mr-2"
									@click="formValues.donation_amount = 100000"
								>
									100 000 ₽
								</button> -->

								<b-button
									variant="outline-primary"
									class="mr-2"
									@click="formValues.donation_amount = 50000"
								>
									50 000 ₽
								</b-button>

								<!-- <button
									type="button"
									class="btn btn-outline-primary mr-2"
									@click="formValues.donation_amount = 10000"
								>
									10 000 ₽
								</button> -->

								<!-- <button
									type="button"
									class="btn btn-outline-primary mr-2"
									@click="formValues.donation_amount = 5000"
								>
									5 000 ₽
								</button> -->
							</div>

							<FormulateInput
								v-if="block.has_recurring_payment"
								label="Тип пожертвования"
								type="CustomRadioGroup"
								name="recurring_payment_schedule"
								:options="{ 0: 'Разово', 1: 'Ежемесячно', 2: 'Ежегодно' }"
								validation="required"
								:validation-messages="{
									required: 'Выберите значение',
								}"
							/>

							<FormulateInput
								v-model="formValues.donation_amount"
								name="donation_amount"
								label="Другая сумма поддержки"
								placeholder="Введите значение в рублях"
								type="number"
								validation="bail|required|max:1000000"
								:validation-messages="{
									required: 'Введите значение в рублях',
									max: 'Максимальное допустимая сумма - 1 млн. рублей',
								}"
							/>
						</div>
					</div>
				</div>

				<div
					v-if="(isAuthorized && block.authentication_required)
						|| !block.authentication_required"
					class="col-12 order-10"
				>
					<div class="row">
						<div v-for="product in order.data.products" :key="product.id" class="col-12">
							<charge-points v-if="order.data.products.type !== 1" v-model="loyaltyData" :price="productsSum" />
						</div>
						<div class="col-12">
							<div v-html="block.footer_text" />
						</div>
						<div class="col-12 col-lg-6">
							<div v-if="block.show_amount" class="amount_block my-4">
								<p class="mb-0 d-flex justify-content-between">
									<span class="title mb-1">Итого</span>
									<span class="title mb-1">
										{{ createMaskAmount(productsSumWithDiscount) }} руб.
									</span>
								</p>
								<p
									v-if="productsSum > 0 && productsSum !== productsSumWithDiscount"
									class="mb-0 d-flex justify-content-end"
								>
									<span class="original_amount">
										{{ createMaskAmount(productsSum) }} руб.
									</span>
								</p>
							</div>
						</div>
						<div class="col-12 mb-4">
							<agreement-input />
							<PublicOfferAgreementInput
								v-for="(item, index) in block.agreements"
								:key="index"
								:href="item"
							/>
							<advertising-mailings-input />
							<loyalty-registration-input />
							<b2b-alumni-input v-if="block.showb2bAlumniInput" />
						</div>
						<div class="col-12">
							<div class="d-flex align-items-center my-2">
								<FormulateErrors class="custom-form-error text-right" />
								<FormulateInput
									type="submit"
									class="mt-2 text-right"
									:disabled="isLoadingSubmit"
								>
									<b-spinner
										v-if="isLoadingSubmit"
										style="margin-right: 15px; width: 1.3em; height: 1.3em;"
									/>
									{{ isLoadingSubmit ? 'Обработка...' : submitBtnText }}
								</FormulateInput>
							</div>
							<CookieError v-if="isErrorCookie" />
						</div>
					</div>
				</div>

				<div v-else>
					<div class="col-12 mb-3">
						Необходимо быть зарегистрированным в системе
					</div>
					<FormulateInput
						type="button"
						class="mb-0 col-12"
						:disabled="isLoadingSubmit"
						@click="showLoginPopup"
					>
						Авторизоваться
					</FormulateInput>
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import b2bAlumniInput from '~/components/panels/formulate/products/components/b2bAlumniInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import PublicOfferAgreementInput from '~/components/panels/formulate/products/components/PublicOfferAgreementInput.vue';
import ChargePoints from '~/components/formulate/loyalty/ChargePoints.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import checkIsBlockShown from '~/mixins/checkIsBlockShown';
import LoyaltyRegistrationInput from '~/components/panels/formulate/products/components/LoyaltyRegistrationInput.vue';
import moment from '@/utils/moment';
import '~/utils/vue-formulate';

import {
	FORMULATE_ORDER_STATUSES,
	ORDER_TYPES,
	ORDER_TYPE,
	FORM_SCENARIO_TYPE,
} from '~/utils/dictionaries';

export default {
	components: {
		LoyaltyRegistrationInput, ChargePoints, AgreementInput, ProductsComponent, AdvertisingMailingsInput, CookieError, b2bAlumniInput, PublicOfferAgreementInput,
	},
	mixins: [formulateFormScenario, checkIsBlockShown],
	data() {
		return {
			productsSumWithDiscount: 0,
			productsSum: 0,
			productsCount: [],
			loyaltyData: null,
			statuses: FORMULATE_ORDER_STATUSES,
			types: ORDER_TYPES,
			FORM_SCENARIO_TYPE,
			ORDER_TYPE,
			order: {
				data: {
					products: [],
				},
			},
			userValues: {},
		};
	},
	computed: {
		isShowDonationBlock() {
			return this.block.class_name === 'RecurringPaymentScenario';
		},
		submitBtnText() {
			switch (this.block.form_scenario_type) {
			case FORM_SCENARIO_TYPE.REGISTRATION:
				return 'Зарегистрироваться';
			case FORM_SCENARIO_TYPE.PAYMENT:
				return 'Перейти к оплате';
			case FORM_SCENARIO_TYPE.DONATION:
				return 'Поддержать';
			default:
				return 'Отправить';
			}
		},
	},
	methods: {
		async handlerChange(selected) {
			this.productsCount = selected;

			await this.$api.getSumProducts({
				form_scenario_id: this.block.scenario_id,
				products: selected.map((el) => ({
					id: el.id,
					quantity: el.quantity,
					price: +el.price,
				})).filter((el) => el.quantity !== 'Выберите количество'),
				promocode: this.isActivatePromocode ? this.promocode : null,
			}).then((res) => {
				this.productsSumWithDiscount = res.sum;
				this.productsSum = res.sumWithoutDiscount;
			});
		},
		checkPromocodeLanding() {
			this.checkPromocode(this.block.products);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
  font-family: $font-family-base !important;
  font-weight: 500 !important;
}

.field-required {
  &.formulate-input[data-classification='text'] input {
    border: 1px solid red !important;
  }
}

.custom-switch {
  line-height: 1.8;
}

.alert-primary {
  color: $white;
  background-color: $link-color;
  border-color: $link-color;
}

.close_link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
  padding: 0;
  border: 0;
  background: transparent;
  outline: 0;
  cursor: pointer;

  &::after {
    position: relative;
    content: "\e915";
    font-family: "sk_icons";
    line-height: 1;
    font-size: .8rem;
    margin-left: 0.5rem;
    padding: 4px;
    cursor: pointer;
  }
}

span {
  margin: 0;
  line-height: 1.3;

  &.price-muted {
    font-size: 1.5rem;
    text-decoration: line-through;
    color: $border-color;
  }
}

.end-price {
  background: #FFFFFF;

  .amount-wrapper {
    border-right: 1px dashed $border-color;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding-right: 30px;
  }
}

.amount {
  font-weight: bold;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  @include media-breakpoint-up(sm) {
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
}

.total-price {
  padding: 1rem;
  border: 1px solid $border-color;
  display: flex;
  background-color: #455FED;
  color: #FFFFFF;
  flex-direction: column;
  justify-content: space-between;
  @include media-breakpoint-up(sm) {
    padding: 2rem 1.5rem;
  }

  .description-small {
    font-weight: 400;
    line-height: 20px;
    color: #9BA9F7;

  }

  .education {
    border-top: 1px solid #FFFFFF;
  }

  input {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid $border-color;
    width: 100%;
    outline-style: none;

    &::placeholder {
      color: $border-color;
    }
  }

  .input_under_span {
    font-size: 0.8rem;
    line-height: 1.2;
    font-weight: normal;
  }

  .btn-outline-secondary {
    color: $border-color;
    border-color: $border-color;

    &:hover {
      color: $white;
      border-color: $link-hover-color;
      background-color: $link-hover-color;
    }
  }

  .sum {
    margin: 2rem 0;
  }
}

.discount {
  .formulate-input-element {
    &.formulate-input-element--text {
      input {
        border: none !important;
        border-bottom: 1px solid black !important;
        padding-left: 0px !important;
        padding-bottom: 1rem !important;

        &::placeholder {
          color: black !important;
        }
      }
    }

    &.formulate-input-element--submit {
      button {
        font-weight: 400 !important;
      }
    }

  }
}

.error-message {
  color: red;
  font-size: 0.8rem;
}

.arrow-right {
  &--black {
    fill: black;
    padding: 0;
    cursor: pointer;
  }
}

.close {
  cursor: pointer;
  opacity: 1;
}

.close::before {
  content: '\e915';
  font-size: 1rem;
}

.amount_block {
  height: 3rem;

  .original_amount {
    color: $border-color;
    font-weight: bold;
    text-decoration: line-through;
  }
}
</style>
